import React, {Component} from 'react';
import SideBarAdmin from './admin/SideBarAdmin';
import '../SideBar.css';
export default class SideBar extends Component {
    render(){
        return (
            <nav className="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
                <div className="container px-4 px-lg-5">
                    <a className="navbar-brand" href="/curriculum"><span className="nvdxaviercolor">NVDXavier</span></a>
                    <button className="navbar-toggler navbar-toggler-right" type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
                            aria-label="Toggle navigation">
                        Menu
                        <i className="fas fa-bars"></i>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                        <ul className="navbar-nav ms-auto">
                            <li className="nav-item"><a className="nav-link" href="/blog">Blog</a></li>
                            <li className="nav-item"><a className="nav-link" href="/curriculum" >About me</a></li>
                            <li className="nav-item"><a className="nav-link" href="/social">Social</a></li>
                            <SideBarAdmin />
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}